import axios from '../axios'
import { checkResponse, getProjectId } from '../utils'
import { apiV1 } from '../utils/constant';

/**
 * @function getAnnouncement
 * @desc 反馈信息
 * @returns {Object}
 */
const getAnnouncement = (page, per, st, ed) => {
  return axios
    .get(`${apiV1}/projects/${getProjectId()}/download/announcement/page?page=${page}&per=${per}&announcementType=1${st && st !== '' ? `&st=${st}` : ''}${ed && ed !== '' ? `&ed=${ed}` : ''}`)
    .then(checkResponse)
}

export {
  getAnnouncement
}
